export default __webpack_public_path__ + "static/alltours-teaser-ce4c5bfd640f080eac1ab3c4d472a32a.png";